import DeviceAssumptionsPage from './DeviceAssumptionsPage';

export default DeviceAssumptionsPage;
